<template>
  <v-banner color="white" single-line style="pa-1" elevation="3">
    <div class="d-flex">
      <v-btn test-tag="tag-147" @click="$emit('top')" icon><v-icon>mdi-chevron-double-up</v-icon></v-btn>
      <v-spacer></v-spacer>
      <v-btn test-tag="tag-148" @click="$emit('up')" icon ><v-icon>mdi-chevron-up</v-icon></v-btn>
      <v-btn test-tag="tag-149" @click="$emit('down')" class="ml-3" icon><v-icon>mdi-chevron-down</v-icon></v-btn>
    </div>
  </v-banner>
</template>

<script>
export default {
  
}
</script>